// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__33TZa","QuizWrapper":"Quiz_QuizWrapper__325lB"};